import { CodementumUrl } from '@cm-frontend/shared/codementum-url';
import { CookieManager } from '@cm-frontend/shared/cookie-manager';
import { useAuthUserOptions } from '@cm-frontend/shared/queries';
import { willRedirect } from '@cm-frontend/utils/redirect.utils';

export default async function (store, queryClient) {
  let authorizationHeaderCookie = CookieManager.get(
    CookieManager.AUTH_COOKIE_NAME
  );
  if (!authorizationHeaderCookie) {
    if (
      store.getters['CodementumUser/authorizationHeader'] === 'null null' ||
      store.getters['Codementumuser/isAuthenticated'] === false
    ) {
      const { redirect, url } = willRedirect(
        new URL(CodementumUrl.panel('login'))
      );
      if (redirect) {
        window.location = url;
      }
      return;
    }
  }
  try {
    const authorizationHeaderPayload = JSON.parse(authorizationHeaderCookie);
    store.commit('CodementumUser/fillState', {
      key: 'auth',
      values: authorizationHeaderPayload
    });
    const { data } = await queryClient.fetchQuery(useAuthUserOptions());
    store.dispatch('CodementumUser/fillUserStates', data);
  } catch {
    /* ignore */
  }
}
